/**
 * useTheme — dark theme is first-class (§1.6, default = system). Persists the user choice.
 */
import { useCallback, useEffect, useState } from "react";

const KEY = "orees-vision-theme";
type Theme = "light" | "dark";

function initial(): Theme {
  const stored = localStorage.getItem(KEY);
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(initial);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  return { dark: theme === "dark", toggle };
}
